import React from 'react';

function Tips(props) {
    return (
        <div>
            <h2>Tips for Cleaning</h2>
            <li>
                <b>GROUT CLEANING:</b> A quick way to clean your grout (not the cheapest) is oxy clean.
                You can use the spray. 
                    <ul>Spray 3 or four times in the square area, </ul>
                    <ul>Let sit for 5 minutes</ul>
                    <ul>ently scrub, wiping the dirt away as you go</ul>
                    <ul>Takes about 70 minutes per small room</ul>
                <b>I can do this for you! Your grout will be sparkling clean like new again.</b>
            </li>
            <br></br>
            <li>
                <b>BACK PROTECTION:</b> What do you use to protect your back when making a lot of hotel beds?
                <ul>YOUR LEGS. So, instead of using your back to bend and lift the heavy mattresses,; using your legs in a squatting position keeps you going on for about 35 beds if you need it.</ul>
            </li>
            <br></br>
            <li>
                <b>WHAT COMES FIRST?</b> TLC Cleaning Quiz: what is the very first thing you clean when beginning a room?
                <ul>Start at the top and work your way down. First, place a protective cover on your bed and clean the ceiling fan/light fixture!</ul>
            </li>
        </div>
    );
}

export default Tips;
